import inlineVideoPlayer from '@/scripts/inline-video-player'
import imageContent from '@/scripts/image-content'
import mapHotspots from '@/scripts/map-hotspots'
import mapHotspotsGoogle from '@/scripts/map-hotspots-google'
import stats from '@/scripts/stats'
import contentCarousel2 from '@/scripts/content-carousel-2'
import pressCarousel from '@/scripts/press-carousel'
import quoteCallout from '@/scripts/quote-callout'

const init = () => {
  inlineVideoPlayer()
  imageContent()
  mapHotspots()
  mapHotspotsGoogle()
  stats()
  contentCarousel2()
  pressCarousel()
  quoteCallout()
}

document.addEventListener('DOMContentLoaded', init)
document.addEventListener('shopify:section:load', init)